export const BTN_TYPES = {
  ACCEPT_ALL: 'ACCEPT_ALL',
  REJECT_ALL: 'REJECT_ALL',
  CUSTOM_COOKIES: 'CUSTOM_COOKIES',
};
